import React from 'react';

import Select from 'shared/components/Select';

import SelectableOption from './SelectableOption';
import { MultiSelectProps } from './types';

const MultiSelect = ({
  optionComponent = SelectableOption,
  ...otherProps
}: MultiSelectProps) => (
  <Select
    isMultiSelect
    optionComponent={optionComponent}
    {...otherProps}
  />
);

export default MultiSelect;
